import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Field as HeadlessField } from '@flywire/react-headlessui';
import { cx } from '../../utils';
export const useRadioClasses = ({ className }) => {
    return cx('peer relative size-5 cursor-pointer appearance-none transition-all', 'rounded-full border border-gray-500', 'before:absolute before:inset-0 before:m-1 before:rounded-full before:bg-white before:opacity-0 before:content-[""]', 'checked:border-blue-600 checked:bg-blue-600 checked:before:opacity-100', 'focus:outline-none focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-600 focus-visible:ring-offset-2 focus-visible:ring-offset-inherit', 'disabled:bg-gray-300 disabled:ring-gray-700', 'aria-[invalid=true]:border-red-600', className);
};
const Radio = forwardRef(({ className, ...restProps }, ref) => {
    const classes = useRadioClasses({ className });
    return _jsx(HeadlessField.Radio, { ...restProps, ref: ref, className: classes });
});
Radio.displayName = 'Radio';
export { Radio };
//# sourceMappingURL=Radio.js.map